// Baselayer Background Checks — staff detail view at /background-checks/:id.
// Renders the Results Explorer (header + tabbed KYB result + add-on sections);
// all rendering parses the relevant rawResponseJson client-side.

import { useParams } from "react-router-dom";
import { ResultsExplorer } from "@/components/backgroundChecks/explorer/ResultsExplorer";

export default function BackgroundCheckDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <ResultsExplorer checkId={id} />;
}
